import React, { useState, useEffect } from 'react';
import { useSite } from '../../context/SiteContext';

const DEFAULT_SLIDES = [
  { slot: 0, defaultUrl: 'https://ckjfwkgtjwiiolqqmnoc.supabase.co/storage/v1/object/public/site-assets/hero_slideshow/0-1779242610519.webp', alt: 'Quầy thuốc Thế Thảo' },
  { slot: 1, defaultUrl: 'https://ckjfwkgtjwiiolqqmnoc.supabase.co/storage/v1/object/public/site-assets/hero_slideshow/1-1779242617650.webp', alt: 'Đội ngũ Thế Thảo' },
  { slot: 2, defaultUrl: 'https://ckjfwkgtjwiiolqqmnoc.supabase.co/storage/v1/object/public/site-assets/hero_slideshow/2-1779242620381.webp', alt: 'Kho vận & Đào tạo Thế Thảo' }
];

export default function HeroSlideshow() {
  const { getImage } = useSite();
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % DEFAULT_SLIDES.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="hero-slideshow" aria-label="Hình ảnh Thế Thảo Pharma">
      {DEFAULT_SLIDES.map((slide, idx) => {
        const url = getImage('hero_slideshow', slide.slot, slide.defaultUrl);
        return (
          <img
            key={idx}
            className={`hero-slide ${idx === current ? 'is-active' : ''}`}
            src={url}
            alt={slide.alt}
            width="1200"
            height="900"
            loading={idx === 0 ? 'eager' : 'lazy'}
          />
        );
      })}
      <div className="hero-slideshow__dots" role="tablist" aria-label="Chọn ảnh">
        {DEFAULT_SLIDES.map((_, idx) => (
          <button
            key={idx}
            type="button"
            className={`hero-dot ${idx === current ? 'is-active' : ''}`}
            onClick={() => setCurrent(idx)}
            aria-label={`Ảnh ${idx + 1}`}
          />
        ))}
      </div>
    </div>
  );
}
